import React, { useEffect, useState } from "react";
import Select from "react-select";

// modal
import Modal from "../Modal";

// style
import RightSidebarStyle from "./style";

// img
import Close from "../../Assets/Close.svg";

// -- redux
import { connect } from "react-redux";
import { AddHome, EditHome, DeleteHome } from "../../Redux/Actions/HomeAction";

function RightSidebar(props) {
  const [response, setResponse] = useState(false);
  const [Title, setTitle] = useState("");
  const [TitleError, setTitleError] = useState("");
  const [Type, setType] = useState("");
  const [TypeID, setTypeID] = useState("");
  const [Information, setInformation] = useState("");
  const [InformationError, setInformationError] = useState("");
  const [AndroidUrl, setAndroidUrl] = useState("");
  const [IOSUrl, setIOSUrl] = useState("");
  const [AndroidInformationError, setAndroidInformationError] = useState("");
  const [IosInformationError, setIosInformationError] = useState("");
  const [InformationID, setInformationID] = useState("");
  const [UserType, setUserType] = useState("");
  const [UserTypeID, setUserTypeID] = useState("");
  const [ImgName, setImgName] = useState("");
  const [base64Icon, setBase64Icon] = useState("");
  const [SVGError, setSVGError] = useState("");
  const [OpenModal, setModal] = useState(false);

  useEffect(() => {
    document.getElementById("SidebarForm").scrollTo(0, 0);
    props.data && setTitle(props.data.boxTitle);
  }, [props]);

  function toArray(obj) {
    if (obj == null) {
      return [];
    } else if (Array.isArray(obj)) {
      return obj;
    } else {
      return [obj];
    }
  }

  function iif(condition, trueObj, falseObj) {
    return condition ? toArray(trueObj) : toArray(falseObj);
  }

  const TypeOptions = [
    { value: "Tab", label: "Tab", id: "1" },
    { value: "App", label: "App", id: "2" },
    // { value: 'Service', label: 'Service', id: '3' },
    { value: "WebView", label: "WebView", id: "4" },
  ];

  const UserTypeOptions = [{ value: "Personal Banking", label: "Personal Banking", id: "2" }, { value: "Business", label: "Business", id: "3" }, ...iif(sessionStorage.getItem("selectedBank") === "1", { value: "V1be User", label: "V1be User", id: "5" })];

  const KeyTabOptions = [
    { value: "Home", label: "Home", id: "1" },
    { value: "Products", label: "Products", id: "2" },
    { value: "Services", label: "Services", id: "3" },
    { value: "Social", label: "Social", id: "4" },
    { value: "Help", label: "Help", id: "5" },
  ];

  const ServiceInformationOptions = [{ value: "Change Name", label: "Change Name", id: "11" }];

  const handleChange = (selected, type) => {
    if (type === "type") {
      setType(selected);
      setTypeID(selected.id);
      setInformation("");
      setInformationID("");
      setAndroidUrl("");
      setIOSUrl("");
      setIosInformationError("");
      setAndroidInformationError("");
    } else if (type === "information") {
      setInformation(selected);
      setInformationID(selected.id);
    } else {
      setUserType(selected);
      setUserTypeID(selected.id);
    }
  };

  const selectUserType = (selected) => {
    handleChange(selected);
    let userValues = "";
    const a = selected.selected.map((item) => {
      userValues += `${item.id},`;
    });
    // setUserType(selected.selected);
    setUserTypeID(userValues.substring(0, userValues.length - 1));
  };

  useEffect(() => {
    if (props.item_data) {
      setTitle(props.item_data.title);
      setBase64Icon(props.item_data.icon);
      setImgName(props.item_data.android_icon && props.item_data.android_icon.split("/")[3]);
      setTypeID(props.item_data.type && props.item_data.type.toString());
      setUserTypeID(props.item_data.user_type && props.item_data.user_type.toString());
      setInformationID(props.item_data.information && props.item_data.information.toString());
      setInformation(props.item_data.information && props.item_data.information);
      props.item_data.app_android_url === null ? setAndroidUrl("") : setAndroidUrl(props.item_data.app_android_url && props.item_data.app_android_url);
      props.item_data.app_ios_url === null ? setIOSUrl("") : setIOSUrl(props.item_data.app_ios_url && props.item_data.app_ios_url);
    }
  }, [props]);

  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: "#3C3C3C",
      border: state.isFocused ? "1px solid #A0A0A0" : "1px solid #3C3C3C",
      transition: "all 0.25s linear 0s",
      "&:hover": {
        border: "1px solid #A0A0A0",
      },
      padding: "4px 6px",
      boxShadow: state.isFocused ? null : null,
    }),
    singleValue: (baseStyles, state) => ({
      ...baseStyles,
      color: state.isFocused ? "#ffffff" : "#ffffff",
      backgroundColor: "#3C3C3C",
    }),
  };

  const convertSvgToBase64 = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target.result;
      console.log(base64String);
      setBase64Icon(base64String);
    };
    reader.onerror = (error) => {
      console.error("Error reading file:", error);
    };
    reader.readAsDataURL(file);
  };

  const handleSvgPreview = (e, type) => {
    if (e.target.files[0].size / 1024 < 2000) {
      if (e.target.files[0].type === "image/svg+xml") {
        e.target.files[0] && setImgName(e.target.files[0].name);
        convertSvgToBase64(e.target.files[0]);
        console.log("DATA", base64Icon);
        setSVGError("");
      } else {
        setSVGError("Only svg is allowed");
      }
    } else {
      setSVGError("File size exceeds");
    }
  };

  const CloseSidebar = (e) => {
    e.preventDefault();
    document.getElementById("SidebarForm").scrollTo(0, 0);
    setTitle("");
    setTitleError("");
    setInformationError("");
    setType("");
    setTypeID("");
    setUserType("");
    setUserTypeID("");
    setInformation("");
    setInformationID("");
    setImgName("");
    setAndroidUrl("");
    setIOSUrl("");
    setIosInformationError("");
    setAndroidInformationError("");
    setBase64Icon("");
    props.close();
  };

  const handleModal = (e, type) => {
    e.preventDefault();
    if (type === "update" || type === "add") {
      let expression = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
      let regex = new RegExp(expression);
      let expressionHttps = /^https:\/\//;
      let regexHttps = new RegExp(expressionHttps);
      if (TypeID === "4") {
        if (Information.match(regex)) {
          setInformationError("");
          setModal(type);
        } else {
          setInformationError("Invalid URL");
        }
      } else if (TypeID === "2") {
        if (AndroidUrl.match(regex) && AndroidUrl.match(regexHttps) && IOSUrl.match(regex) && IOSUrl.match(regexHttps)) {
          setAndroidInformationError("");
          setIosInformationError("");
          setModal(type);
        } else {
          if (AndroidUrl.match(regex) && AndroidUrl.match(regexHttps)) {
            setAndroidInformationError("");
          }
          if (IOSUrl.match(regex) && IOSUrl.match(regexHttps)) {
            setIosInformationError("");
          }
          if (AndroidUrl.match(regex) === null || AndroidUrl.match(regexHttps) === null) {
            setAndroidInformationError("Invalid URL");
          }
          if (IOSUrl.match(regex) === null || IOSUrl.match(regexHttps) === null) {
            setIosInformationError("Invalid URL");
          }
        }
      } else {
        setInformationError("");
        setIosInformationError("");
        setAndroidInformationError("");
        setModal(type);
      }
    } else {
      setInformationError("");
      setIosInformationError("");
      setAndroidInformationError("");
      setModal(type);
    }
  };

  useEffect(() => {
    setTimeout(function () {
      setResponse(true);
    }, 1000);
  }, []);

  const CloseModal = (e, type) => {
    e.preventDefault();
    document.getElementById("SidebarForm").scrollTo(0, 0);
    setResponse(true);
    if (type === "add_yes") {
      if (TypeID !== "4") {
        if (TypeID === "2") {
          const data = {
            title: Title,
            user_type: UserTypeID,
            type: TypeID,
            information: "",
            app_android_url: AndroidUrl,
            app_ios_url: IOSUrl,
            icon: base64Icon,
          };
          props.AddHome(data);
        } else {
          const data = {
            title: Title,
            user_type: UserTypeID,
            type: TypeID,
            information: InformationID,
            icon: base64Icon,
          };
          props.AddHome(data);
        }
      } else if (TypeID === "2") {
        const data = {
          title: Title,
          user_type: UserTypeID,
          type: TypeID,
          information: "",
          app_android_url: AndroidUrl,
          app_ios_url: IOSUrl,
          icon: base64Icon,
        };
        props.AddHome(data);
      } else {
        const data = {
          title: Title,
          user_type: UserTypeID,
          type: TypeID,
          information: Information,
          icon: base64Icon,
        };
        props.AddHome(data);
      }
    } else if (type === "add_no") {
      setModal(false);
    } else if (type === "update_yes") {
      if (TypeID !== "4") {
        if (TypeID === "2") {
          const data = {
            id: props.item_data.id,
            title: Title,
            user_type: UserTypeID,
            type: TypeID,
            information: "",
            app_android_url: AndroidUrl,
            app_ios_url: IOSUrl,
            icon: base64Icon,
          };
          props.EditHome(data);
        } else {
          const data = {
            id: props.item_data.id,
            title: Title,
            user_type: UserTypeID,
            type: TypeID,
            information: InformationID,
            icon: base64Icon,
          };
          props.EditHome(data);
        }
      } else {
        const data = {
          id: props.item_data.id,
          title: Title,
          // iosIcon: PdfSrc,
          // androidIcon: ImgSrc,
          user_type: UserTypeID,
          type: TypeID,
          information: Information,
          icon: base64Icon,
        };
        console.log(data);
        props.EditHome(data);
      }
    } else if (type === "update_no") {
      setModal(false);
    } else if (type === "delete_yes") {
      props.DeleteHome(props.item_data.id);
    } else if (type === "delete_no") {
      setModal(false);
    }
    if (type === "add_yes" || type === "update_yes" || type === "delete_yes") {
      setModal(false);
      setTitle("");
      setType("");
      setTypeID("");
      setUserType("");
      setUserTypeID("");
      setInformation("");
      setInformationID("");
      setImgName("");
      setAndroidUrl("");
      setIOSUrl("");
      setIosInformationError("");
      setAndroidInformationError("");
      setBase64Icon("");
      props.close();
    }
  };

  const findType = (selected) => {
    for (let i = 0; i < TypeOptions.length; i++) {
      if (parseInt(TypeOptions[i].id) === parseInt(selected)) {
        return TypeOptions[i];
      }
    }
  };

  const handleTitle = (e) => {
    if (e.target.value.length < 70) {
      if (e.target.value.length < 6) {
        setTitleError("Title must be min. 6 characters");
      } else {
        setTitleError("");
      }
      setTitle(e.target.value);
    } else {
      setTitleError("Title must be less than 70 characters");
    }
  };

  useEffect(() => {
    props.edit_data && response && props.response({ type: props.edit_data.status, message: props.edit_data.message });
  }, [props.edit_data]);

  useEffect(() => {
    props.delete_data && response && props.response({ type: props.delete_data.status, message: props.delete_data.message });
  }, [props.delete_data]);

  useEffect(() => {
    props.add_data && response && props.response({ type: props.add_data.status, message: props.add_data.message });
  }, [props.add_data]);

  return (
    <>
      {props && props.sidebar && <div onClick={(e) => CloseSidebar(e)} className="dark-overlay" />}
      <div className={props && props.sidebar ? "dark-background right-sidebar-wrap" : "dark-background right-sidebar-wrap right-sidebar-wrap-close"}>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="text-uppercase text-white">{props.Type} HOME SCREEN ITEM</h5>
          <img onClick={(e) => CloseSidebar(e)} src={Close} alt="Close" className="cursor-pointer" />
        </div>
        <form className="sidebar-form-wrap" id="SidebarForm">
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              Title <span className="text-danger">*</span>
            </label>
            <input value={Title} onChange={(e) => handleTitle(e)} type="text" placeholder="Enter Title" className="w-100 input-style" />
            {TitleError && <p className="ml-2 f-12 text-danger">{TitleError}</p>}
          </div>
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              Icon<span className="text-danger">*</span>
            </label>
            <div className="d-flex justify-content-between">
              <div className="text-center" title={ImgName}>
                <label className="custom-file-upload position-relative d-flex align-items-center justify-content-center mb-0">
                  <input
                    type="file"
                    accept="image/svg+xml"
                    onClick={(e) => (e.target.value = null)}
                    onChange={(e) => {
                      handleSvgPreview(e, "svg");
                    }}
                  />
                  <div className="w-100">
                    {base64Icon !== "" ? <img src={base64Icon} alt="svg-icon" style={{ width: "30%", height: "30%", objectFit: "contain" }} /> : <span>Click to browse</span>}
                    {base64Icon !== "" && <p className="text-white mb-0 mt-1 col-12 ml-auto mr-auto text-truncate">{ImgName}</p>}
                    {base64Icon !== "" && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setImgName("");
                          setBase64Icon("");
                        }}
                        className="remove-button"
                      >
                        <p className="text-uppercase mb-0 text-white">Remove</p>
                      </div>
                    )}
                  </div>
                </label>
                <span style={{ color: "#A0A0A0" }} className="f-12">
                  Upload SVG
                </span>
                {SVGError && <span className="f-12 text-danger d-block">{SVGError}</span>}
              </div>
            </div>
          </div>
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              Type<span className="text-danger">*</span>
            </label>
            <Select isSearchable={false} value={findType(TypeID)} onChange={(e) => handleChange(e, "type")} options={TypeOptions} styles={colourStyles} placeholder="Choose Type" />
          </div>
          {TypeID === "1" && (
            <div className="mt-4">
              <label className="text-grey-6 f-16 d-block mb-1">
                Key<span className="text-danger">*</span>
              </label>
              <Select
                value={
                  KeyTabOptions.filter(function (option) {
                    return option.id === InformationID;
                  }) || ""
                }
                onChange={(e) => handleChange(e, "information")}
                options={KeyTabOptions}
                styles={colourStyles}
                placeholder="Choose Type"
              />
            </div>
          )}

          {TypeID === "2" && (
            <>
              <div className="mt-4">
                <label className="text-grey-6 f-16 d-block mb-1">
                  IOS url<span className="text-danger">*</span>
                </label>
                <input value={IOSUrl} onChange={(e) => setIOSUrl(e.target.value)} type="text" placeholder="Enter url" className="w-100 input-style" id="Key" />
                {IosInformationError && <p className="f-12 text-danger">{IosInformationError}</p>}
              </div>
              <div className="mt-4">
                <label className="text-grey-6 f-16 d-block mb-1">
                  Android url<span className="text-danger">*</span>
                </label>
                <input value={AndroidUrl} onChange={(e) => setAndroidUrl(e.target.value)} type="text" placeholder="Enter url" className="w-100 mt-2 input-style" id="Key" />
                {AndroidInformationError && <p className="f-12 text-danger">{AndroidInformationError}</p>}
              </div>
            </>
          )}
          {TypeID === "3" && (
            <div className="mt-4">
              <label className="text-grey-6 f-16 d-block mb-1">
                Key<span className="text-danger">*</span>
              </label>
              <Select
                value={
                  ServiceInformationOptions.filter(function (option) {
                    return option.id === InformationID;
                  }) || ""
                }
                onChange={(e) => handleChange(e, "information")}
                options={ServiceInformationOptions}
                styles={colourStyles}
                placeholder="Choose Type"
              />
            </div>
          )}
          {TypeID === "4" && (
            <div className="mt-4">
              <label htmlFor="Key" className="text-grey-6 f-16 d-block mb-1">
                Key <span className="text-danger">*</span>
              </label>
              <input value={Information} onChange={(e) => setInformation(e.target.value)} type="text" placeholder="Enter url" className="w-100 input-style" id="Key" />
              {InformationError && <p className="f-12 text-danger">{InformationError}</p>}
            </div>
          )}
          <div className="mt-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              User Type<span className="text-danger">*</span>
            </label>
            <Select
              value={
                UserTypeOptions.filter(function (option) {
                  return UserTypeID.indexOf(option.id) !== -1 ? option.id : UserTypeID == 1 ? option : "";
                }) || ""
              }
              onChange={(selected) => selectUserType({ selected })}
              options={UserTypeOptions}
              styles={colourStyles}
              isMulti={true}
              placeholder="Choose Type"
            />
          </div>
          <div className="mt-5 mb-3 text-right">
            {props.Type === "Add" && (
              <>
                {TypeID === "2" ? (
                  <button onClick={(e) => handleModal(e, "add")} className="form-button" disabled={!(Title && Type && UserType && base64Icon && AndroidUrl && IOSUrl && Title.length >= 6)}>
                    Save
                  </button>
                ) : (
                  <button onClick={(e) => handleModal(e, "add")} className="form-button" disabled={!(Title && Type && UserType && base64Icon && (Information || InformationID) && Title.length >= 6)}>
                    Save
                  </button>
                )}
              </>
            )}
            {props.Type === "Edit" && (
              <div className="d-flex align-items-center justify-content-center">
                <button onClick={(e) => handleModal(e, "delete")} className="form-button form-button-ghost f-14 mr-2">
                  Delete
                </button>
                {(TypeID === "1" || TypeID === "3") && (
                  <button disabled={!(Title && (Information || InformationID) && base64Icon && TypeID && UserTypeID && Title.length >= 6)} onClick={(e) => handleModal(e, "update")} className="form-button ml-2 f-14">
                    Update
                  </button>
                )}
                {TypeID === "2" && (
                  <button disabled={!(Title && AndroidUrl && IOSUrl && base64Icon && TypeID && UserTypeID && Title.length >= 6)} onClick={(e) => handleModal(e, "update")} className="form-button ml-2 f-14">
                    Update
                  </button>
                )}
                {TypeID === "4" && (
                  <button disabled={!(Title && (Information || InformationID) && base64Icon && TypeID && UserTypeID && Title.length >= 6)} onClick={(e) => handleModal(e, "update")} className="form-button ml-2 f-14">
                    Update
                  </button>
                )}
              </div>
            )}
          </div>
        </form>
      </div>
      {OpenModal && <Modal Name={Title} Type={OpenModal} Close={(e, type) => CloseModal(e, type)} />}
      <RightSidebarStyle />
    </>
  );
}

const mapStateToProps = ({ HomeReducer }) => {
  const { loading, data, edit_data, delete_data, add_data } = HomeReducer;
  return { loading, data, edit_data, delete_data, add_data };
};

const mapDispatchToProps = {
  AddHome,
  EditHome,
  DeleteHome,
};

export default connect(mapStateToProps, mapDispatchToProps)(RightSidebar);
